import { gql } from "@apollo/client";

export const getKycQuery = gql`
query GetKycApplication($customerId: String!) {
  getKycApplication: getKycApplication_Admin(customerId: $customerId) {
      id
      type
      status
      details {
          individual {
              firstName
              lastName
              applicantId
          }
          company {
              id
              typeOfBusiness
              reasonForUse
              sumsubApplicantId
              sumsubApplicationStatus
              bridgeApplicationStatus
          }
      }
    }
  }
`

export const getKycVerificationDetailsQuery = gql`
query GetKycVerificationDetails($customerId: String!) {
  getKycVerificationDetails: getKycVerificationDetails_Admin(customerId: $customerId) {
      id
      customerId
      status
      verificationType
      kyc {
          firstName
          lastName
          email
          phoneNumber
          dob
          address {
              street
              suburb
              state
              postcode
              country
          }
          sepaEnabled
          signedAgreementId
          taxIdType
          taxIdTypeDescription
          taxIdCountryCode
          expectedMonthlyPayments
          documentCountryCode
          documentType
          countryOfResidence
          additionalDetails {
              isIntermediary
              employmentStatus
              mostRecentOccupationCode
              accountPurpose
              sourceOfFunds
          }
      }
    }
  }
`